import { lazy, ReactNode, Suspense, useState } from 'react';

import InviteToWorkspaceModal from '@/shared/components/modals/GlobalModals/InviteToWorkspaceModal';
import MoveResourceToFolderModal from '@/shared/components/modals/ResourceActionModals/02-MoveResourceToFolderModal';
import AddDataSourceModal from '@/shared/components/modals/ResourceCreationModals/AddDataSourceModal';
import CreateDashboardModal from '@/shared/components/modals/ResourceCreationModals/CreateDashboardModal';
import CreateTaskModal from '@/shared/components/modals/ResourceCreationModals/CreateTaskModal';

const CreateFolderModal = lazy(() => import('@/shared/components/modals/ResourceCreationModals/CreateFolderModal'));
const CreateInvestmentModal = lazy(
    () => import('@/shared/components/modals/ResourceCreationModals/CreateInvestmentModal'),
);
const CreateListModal = lazy(() => import('@/shared/components/modals/ResourceCreationModals/CreateListModal'));
const CreatePipelineModal = lazy(() => import('@/shared/components/modals/ResourceCreationModals/CreatePipelineModal'));
const CreateTeamModal = lazy(() => import('@/shared/components/modals/ResourceCreationModals/CreateTeamModal'));

const renderLazyModal = (modal: ReactNode) => <Suspense fallback={null}>{modal}</Suspense>;

export const useCreationModalMaps = () => {
    const [creationModalOpen, setCreationModalOpen] = useState<boolean>(false);

    const creationModalMap = {
        folders: renderLazyModal(<CreateFolderModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        investments: renderLazyModal(<CreateInvestmentModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        pipelines: renderLazyModal(<CreatePipelineModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        teams: renderLazyModal(<CreateTeamModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        dashboards: renderLazyModal(<CreateDashboardModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        lists: renderLazyModal(<CreateListModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        tasks: renderLazyModal(<CreateTaskModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        addDataSource: renderLazyModal(<AddDataSourceModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        moveResourceToFolder: renderLazyModal(
            <MoveResourceToFolderModal open={creationModalOpen} setOpen={setCreationModalOpen} />,
        ),
        inviteToWorkspace: renderLazyModal(
            <InviteToWorkspaceModal open={creationModalOpen} setOpen={setCreationModalOpen} />,
        ),
    } as Record<string, ReactNode>;

    const singularCreationModalMap = {
        folder: renderLazyModal(<CreateFolderModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        investment: renderLazyModal(<CreateInvestmentModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        pipeline: renderLazyModal(<CreatePipelineModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        team: renderLazyModal(<CreateTeamModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        dashboard: renderLazyModal(<CreateDashboardModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        list: renderLazyModal(<CreateListModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        task: renderLazyModal(<CreateTaskModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        addDataSource: renderLazyModal(<AddDataSourceModal open={creationModalOpen} setOpen={setCreationModalOpen} />),
        moveResourceToFolder: renderLazyModal(
            <MoveResourceToFolderModal open={creationModalOpen} setOpen={setCreationModalOpen} />,
        ),
        inviteToWorkspace: renderLazyModal(
            <InviteToWorkspaceModal open={creationModalOpen} setOpen={setCreationModalOpen} />,
        ),
    } as Record<string, ReactNode>;

    const creationModalMaps = {
        creationModalOpen,
        setCreationModalOpen,
        creationModalMap,
        singularCreationModalMap,
    };

    return creationModalMaps;
};
